import React, { FC, Fragment } from 'react';
import { useTheme } from '@mui/material';
import { px2rem } from '../../core';
import CloseIcon from '../../common/icon/CloseIcon';

interface ImageCardProps extends React.HTMLAttributes<HTMLDivElement> {
    url?: string;
    onRemove?: () => void;
    onSelect: () => void;
}

const ImageCard: FC<ImageCardProps> = ({ url, onRemove, onSelect, ...props }) => {
    const theme = useTheme();

    return (
        <div {...props}>
            <div
                css={{
                    width: '100%',
                    paddingTop: '100%',
                    position: 'relative',
                }}
            >
                <div
                    css={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        color: theme.palette.primary50,
                        background: 'white',
                        borderRadius: px2rem(5),
                        border: `1px solid ${theme.palette.primary40}`,
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {url && (
                        <Fragment>
                            <img
                                src={url}
                                css={{
                                    objectFit: 'contain',
                                    height: '100%',
                                    cursor: 'pointer',
                                }}
                                onClick={onSelect}
                            />
                            {onRemove && (
                                <div
                                    css={{
                                        position: 'absolute',
                                        right: px2rem(4),
                                        top: px2rem(4),
                                        zIndex: 10,
                                        background: '#FFFFFF',
                                        boxShadow: '0.747621px 2.24286px 5.23335px rgba(0, 0, 0, 0.15)',
                                        borderRadius: 4,
                                        width: px2rem(30),
                                        height: px2rem(30),
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: theme.palette.primary.main,
                                        cursor: 'pointer',
                                    }}
                                    onClick={onRemove}
                                >
                                    <CloseIcon />
                                </div>
                            )}
                        </Fragment>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ImageCard;
